(() => {
  const initial = new URL(location.href);
  const params = new Map(['view','preview_theme_id'].filter(k=>initial.searchParams.has(k)).map(k=>[k,initial.searchParams.get(k)]));
  const instances = new Map();
  const write = (el,value) => { if(el && el.textContent !== String(value)) el.textContent = value; };
  class MugPurchase {
    constructor(node) {
      this.node=node;this.section=node.closest('.shopify-section');this.form=this.section.querySelector('product-form form');
      this.config=JSON.parse(node.querySelector('[data-pbm-config]').textContent);this.variant=this.config.variant;
      this.mode='loading';this.configuredIds=null;this.status=node.querySelector('[data-pbm-status]');
      this.bar=node.querySelector('[data-pbm-mobile]');this.button=this.bar.querySelector('button');document.body.append(this.bar);
      this.abort=new AbortController();const signal=this.abort.signal;
      this.money=new Intl.NumberFormat(this.config.locale==='no'?'nb-NO':this.config.locale,{style:'currency',currency:this.config.currency,minimumFractionDigits:2,maximumFractionDigits:2});
      this.section.addEventListener('change',e=>{if(e.target.closest('variant-radios,variant-selects'))this.pending=true;this.update()},{signal});
      this.section.addEventListener('input',()=>this.update(),{signal});
      document.addEventListener('afterVariantChanged',e=>{if(e.detail?.sectionId!==node.dataset.section)return;this.variant=e.detail.variant;this.pending=false;this.clearStatus();this.update()},{signal});
      this.section.addEventListener('click',e=>{
        if(!e.target.closest('.product-form__submit,.customily-personalize-button'))return;
        if(this.blocked()) {e.preventDefault();e.stopImmediatePropagation();this.announce();}
      },{capture:true,signal});
      this.section.addEventListener('submit',e=>{
        if(e.target===this.form&&this.blocked()){e.preventDefault();e.stopImmediatePropagation();this.announce();}
      },{capture:true,signal});
      this.button.addEventListener('click',()=>{
        if(this.blocked()){this.announce();return;}
        const target=this.action();
        if(target&&!target.disabled&&!this.pending){
          target.click();this.position();
          setTimeout(()=>{const error=this.section.querySelector('.product-form__error-message-wrapper:not([hidden])');if(error?.getBoundingClientRect().height)error.scrollIntoView({behavior:'smooth',block:'center'})},500);
        }
      },{signal});
      let queued=false;
      this.observer=new MutationObserver(()=>{if(queued)return;queued=true;queueMicrotask(()=>{queued=false;if(this.node.isConnected)this.update();});});
      this.observer.observe(this.section,{attributes:true,attributeFilter:['disabled','class','style'],childList:true,characterData:true,subtree:true});
      let positionQueued=false;const position=()=>{if(positionQueued)return;positionQueued=true;requestAnimationFrame(()=>{positionQueued=false;this.position()})};
      window.addEventListener('scroll',position,{passive:true,signal});window.addEventListener('resize',position,{signal});document.addEventListener('click',()=>setTimeout(position,150),{signal});
      this.update();this.loadConfiguration();
    }
    native(){this.form=this.section.querySelector('product-form form');return this.form?.querySelector('.product-form__submit:not(.customily-personalize-button)')}
    personalizer(){return window.PBPersonalization.action()}
    action(){return this.mode==='personalized'||this.mode==='posterly'?this.personalizer():this.mode==='standard'?this.native():null}
    blocked(){return this.mode==='loading'||this.mode==='error'||!!this.pending||(this.mode==='personalized'&&(!this.personalizer()||(this.configuredIds&&!this.configuredIds.has(String(this.variant?.id)))))}
    clearStatus(){if(this.status)this.status.hidden=true}
    announce(){
      if(!this.status)return;
      const unconfigured=this.mode==='personalized'&&this.configuredIds&&!this.configuredIds.has(String(this.variant?.id));
      write(this.status,this.mode==='error'?this.config.error:unconfigured?this.config.unconfigured:this.config.loading);this.status.hidden=false;
    }
    async loadConfiguration(){
      const state=await window.PBPersonalization.ready;
      this.mode=state.mode==='customily'?'personalized':state.mode;
      this.configuredIds=state.configuredIds;
      if(this.mode==='error')this.announce();else this.clearStatus();
      this.update();
    }
    update(){
      const native=this.native(),app=this.personalizer();
      const quantity=Math.max(1,Number(this.form?.querySelector('[name=quantity]')?.value)||1);
      if(this.mode==='personalized' && app){
        const text=[...app.childNodes].find(n=>n.nodeType===Node.TEXT_NODE&&n.textContent.trim());
        if(text){if(text.textContent.trim()!==(this.config.personalize||window.PBPersonalization.labels.personalize))text.textContent=(this.config.personalize||window.PBPersonalization.labels.personalize);}
        else {const span=app.querySelector('span');if(span)write(span,(this.config.personalize||window.PBPersonalization.labels.personalize));}
      }
      const value=this.variant?this.money.format(this.variant.price*quantity/100):'—';
      if(this.variant){const sale=this.variant.compare_at_price>this.variant.price;for(const scope of this.section.querySelectorAll('[id^=price-]')){write(scope.querySelector(sale?'.price-item--sale':'.price__regular .price-item--regular'),this.money.format(this.variant.price/100));if(sale)write(scope.querySelector('.price__sale .price-item--regular'),this.money.format(this.variant.compare_at_price/100))}}
      write(this.node.querySelector('[data-pbm-total]'),value);write(this.bar.querySelector('[data-pbm-mobile-total]'),value);
      write(this.bar.querySelector('[data-pbm-selection]'),[this.variant?.title==='Default Title'?'':this.variant?.title,`${this.config.quantity}: ${quantity}`].filter(Boolean).join(' · '));
      const target=this.action();
      this.button.disabled=this.blocked()||!this.variant?.available||!target||target.disabled||target.classList.contains('loading');
      write(this.button,(this.mode==='personalized'||this.mode==='posterly')?(this.config.personalize||window.PBPersonalization.labels.personalize):native?.disabled?native.innerText.trim():this.config.add);
      if(this.node.dataset.pbmMode!==this.mode)this.node.dataset.pbmMode=this.mode;
      this.position();
    }
    position(){
      const target=this.action()||this.native(),rect=target?.getBoundingClientRect();
      const drawer=[...document.querySelectorAll('cart-drawer.active,.drawer.active,dialog[open],.customily-modal,.customily-modal-container')].some(e=>e.getBoundingClientRect().height>0&&getComputedStyle(e).visibility!=='hidden');
      const show=matchMedia('(max-width:749px)').matches&&!!rect&&rect.height>0&&rect.bottom<0&&!drawer;
      this.bar.hidden=!show;document.body.classList.toggle('pbp-mobile-open',show);
      const preview=document.querySelector('#PBarNextFrameWrapper,#preview-bar-iframe')?.getBoundingClientRect();
      const offset=preview&&preview.height<120&&preview.bottom>=innerHeight-3?preview.height:0;
      this.bar.style.bottom=`${offset}px`;document.body.style.setProperty('--pbp-preview-offset',`${offset}px`);
    }
    destroy(){this.abort.abort();clearTimeout(this.configurationTimeout);this.observer.disconnect();this.bar.remove();document.body.classList.remove('pbp-mobile-open')}
  }

  function init(){for(const [node,instance] of instances)if(!node.isConnected){instance.destroy();instances.delete(node)}document.querySelectorAll('[data-pbm-purchase]').forEach(node=>{if(!instances.has(node))instances.set(node,new MugPurchase(node))})}
  document.addEventListener('afterVariantChanged',()=>{if(!params.size)return;const url=new URL(location.href);for(const [k,v] of params)url.searchParams.set(k,v);history.replaceState(history.state,'',url)});
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',e=>{for(const [node,instance] of instances)if(e.target.contains(node)){instance.destroy();instances.delete(node)}});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();


if (!customElements.get('pb-mug-free-shipping')) {
  customElements.define('pb-mug-free-shipping', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.labels = JSON.parse(this.querySelector('script').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale === 'no' ? 'nb-NO' : this.dataset.locale, {style:'currency',currency:'NOK',minimumFractionDigits:2,maximumFractionDigits:2});
      this.render(Number(this.dataset.total));
      const refresh = () => this.refresh();
      for (const event of ['afterCartChanged','afterUpdateQuantity','afterDiscountUpdate']) document.addEventListener(event, refresh, {signal:this.abort.signal});
      window.addEventListener('pageshow', refresh, {signal:this.abort.signal});
      document.addEventListener('visibilitychange', () => {if (!document.hidden) this.refresh()}, {signal:this.abort.signal});
    }
    async refresh() {
      const revision = this.revision = (this.revision || 0) + 1;
      try {
        const response = await fetch(this.dataset.cartUrl, {headers:{Accept:'application/json'},cache:'no-store',signal:this.abort.signal});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (revision !== this.revision || !this.isConnected) return;
        this.hidden = cart.currency !== 'NOK';
        if (!this.hidden) this.render(cart.total_price);
      } catch (error) {
        if (error.name !== 'AbortError' && revision === this.revision) this.hidden = true;
      }
    }
    render(total) {
      const threshold = Number(this.dataset.threshold);
      const remaining = Math.max(0, threshold - total);
      const progress = Math.max(0, Math.min(100, total / threshold * 100));
      const message = remaining === 0 ? this.labels.reached : total === 0 ? this.labels.empty : this.labels.remaining.replace('__AMOUNT__', this.money.format(remaining / 100));
      const text = this.querySelector('[data-pbm-shipping-message]');
      if (text.textContent !== message) text.textContent = message;
      const track = this.querySelector('[role=progressbar]');
      track.setAttribute('aria-valuenow', String(Math.round(progress)));
      track.setAttribute('aria-valuetext', message);
      track.firstElementChild.style.width = `${progress}%`;
      this.classList.toggle('is-complete', remaining === 0);
    }
    disconnectedCallback() {this.abort?.abort()}
  });
}
